// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__o6fYH.styles_ocean-50__czwkt {
  color: #e6f2ff;
}

.styles_color__o6fYH.styles_ocean-100__5HLJj {
  color: #e6f2ff;
}

.styles_color__o6fYH.styles_ocean-200__7neRB {
  color: #b3daff;
}

.styles_color__o6fYH.styles_ocean-300__ixbQ2 {
  color: #7abfff;
}

.styles_color__o6fYH.styles_ocean-400__T9bH0 {
  color: #2392fb;
}

.styles_color__o6fYH.styles_ocean-500__omUzj {
  color: #0074e0;
}

.styles_color__o6fYH.styles_ocean-600__k\\+7ye {
  color: #043571;
}

.styles_color__o6fYH.styles_space-50__DS-hN {
  color: #f0f0f0;
}

.styles_color__o6fYH.styles_space-100__SWd14 {
  color: #e3e3e3;
}

.styles_color__o6fYH.styles_space-200__Xg96X {
  color: #bfbfbf;
}

.styles_color__o6fYH.styles_space-300__2y3Xs {
  color: gray;
}

.styles_color__o6fYH.styles_space-400__7voLU {
  color: #616161;
}

.styles_color__o6fYH.styles_space-500__eS\\+XI {
  color: #283439;
}

.styles_color__o6fYH.styles_gray-50__5J7oC {
  color: #eff3f6;
}

.styles_color__o6fYH.styles_gray-100__oFu3X {
  color: #e6ecef;
}

.styles_color__o6fYH.styles_gray-200__MO5a2 {
  color: #cfd8de;
}

.styles_color__o6fYH.styles_gray-300__DT\\+Ji {
  color: #a8b9c2;
}

.styles_color__o6fYH.styles_gray-400__EH3C- {
  color: #7e98a5;
}

.styles_color__o6fYH.styles_gray-500__M58PQ {
  color: #738f9c;
}

.styles_color__o6fYH.styles_green-50__WyTUt {
  color: #e3fdf6;
}

.styles_color__o6fYH.styles_green-100__8JElG {
  color: #c5f6ea;
}

.styles_color__o6fYH.styles_green-200__etR4\\+ {
  color: #69ddc2;
}

.styles_color__o6fYH.styles_green-300__negIl {
  color: #45bfa3;
}

.styles_color__o6fYH.styles_green-400__\\+Pu\\+A {
  color: #1cab8a;
}

.styles_color__o6fYH.styles_green-500__NuadJ {
  color: #128268;
}

.styles_color__o6fYH.styles_red-50__ykCmL {
  color: #fff0f3;
}

.styles_color__o6fYH.styles_red-100__bLXK8 {
  color: #f9d2db;
}

.styles_color__o6fYH.styles_red-200__9TFc9 {
  color: #f8b4c4;
}

.styles_color__o6fYH.styles_red-300__-y15i {
  color: #e85e81;
}

.styles_color__o6fYH.styles_red-400__KGtrn {
  color: #e23661;
}

.styles_color__o6fYH.styles_red-500__62tZO {
  color: #b82348;
}

.styles_color__o6fYH.styles_yellow-50__7tm-- {
  color: #fffae6;
}

.styles_color__o6fYH.styles_yellow-100__3scA\\+ {
  color: #fff0b3;
}

.styles_color__o6fYH.styles_yellow-200__w4Rpv {
  color: #ffe380;
}

.styles_color__o6fYH.styles_yellow-300__R6EgK {
  color: #ffcf57;
}

.styles_color__o6fYH.styles_yellow-400__4OEC5 {
  color: #ffc60a;
}

.styles_color__o6fYH.styles_yellow-500__6phcY {
  color: #ffb700;
}

.styles_color__o6fYH.styles_orange-50__BHjRW {
  color: #fff2eb;
}

.styles_color__o6fYH.styles_orange-100__Diuhi {
  color: #ffe4d6;
}

.styles_color__o6fYH.styles_orange-200__HWCSN {
  color: #ffc69e;
}

.styles_color__o6fYH.styles_orange-300__zWIAI {
  color: #ffa047;
}

.styles_color__o6fYH.styles_orange-400__0PcH8 {
  color: #ff7b42;
}

.styles_color__o6fYH.styles_orange-500__uq07l {
  color: #ee4920;
}

.styles_color__o6fYH.styles_turquoise-50__yQ8m2 {
  color: transparent;
}

.styles_color__o6fYH.styles_turquoise-100__snH\\+d {
  color: #e6fcff;
}

.styles_color__o6fYH.styles_turquoise-200__puy-E {
  color: #b3f5ff;
}

.styles_color__o6fYH.styles_turquoise-300__8lXUy {
  color: #78e2f2;
}

.styles_color__o6fYH.styles_turquoise-400__zhAGn {
  color: #00c7e6;
}

.styles_color__o6fYH.styles_turquoise-500__41TYD {
  color: transparent;
}

.styles_color__o6fYH.styles_turquoise-600__lFupq {
  color: transparent;
}

.styles_color__o6fYH.styles_violet-50__2eilp {
  color: #eae6ff;
}

.styles_color__o6fYH.styles_violet-100__M7EsS {
  color: #d9d1ff;
}

.styles_color__o6fYH.styles_violet-200__JuQLG {
  color: #bfb3ff;
}

.styles_color__o6fYH.styles_violet-300__Ovdkb {
  color: #9d90ea;
}

.styles_color__o6fYH.styles_violet-400__DQt5F {
  color: #8678d9;
}

.styles_color__o6fYH.styles_violet-500__hKMKK {
  color: #6f5ccc;
}

.styles_color__o6fYH.styles_snow-50__SR8Ux {
  color: white;
}

.styles_color__o6fYH.styles_snow-100__-5rAI {
  color: #f7f7f7;
}

.styles_color__o6fYH.styles_snow-200__wUuGL {
  color: #f0efef;
}

.styles_color__o6fYH.styles_snow-300__irIOX {
  color: #e6e6e6;
}

.styles_color__o6fYH.styles_snow-400__zLgsL {
  color: #e1e0e0;
}

.styles_color__o6fYH.styles_snow-500__bnjaN {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__UdcmN.styles_ocean__GnNvy {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__UdcmN.styles_ocean-light__JXSG5 {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__UdcmN.styles_green__zFnKR {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__UdcmN.styles_green-light__w1SKn {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__UdcmN.styles_red__HWsPQ {
  background-color: #e23661;
  color: white;
}

.styles_background-color__UdcmN.styles_red-light__tYwt3 {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__UdcmN.styles_orange__sdYJb {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__UdcmN.styles_orange-light__yOBKU {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__UdcmN.styles_space__6MuCX {
  background-color: #616161;
  color: white;
}

.styles_background-color__UdcmN.styles_space-light__xcWZ9 {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__UdcmN.styles_gray-light__\\+JICI {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__UdcmN.styles_violet__JcYpv {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__UdcmN.styles_violet-light__qpPvi {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__UdcmN.styles_yellow__WCI7J {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__UdcmN.styles_yellow-light__0veC3 {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
.styles_root__ifwUT {
  transition: background-color 300ms cubic-bezier(0.445, 0.05, 0.55, 0.95) 0ms;
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  flex: 0 0 auto;
  justify-content: center;
  overflow: visible;
  text-align: center;
  /* TODO: make color classes camelCase and remove this: */
  /* stylelint-disable-next-line selector-class-pattern */
}
.styles_root__ifwUT[disabled] {
  opacity: 0.5;
}
.styles_root__ifwUT.styles_small__IfewV {
  height: 36px;
  width: 36px;
}
.styles_root__ifwUT.styles_medium__xPzk1 {
  height: 45px;
  width: 45px;
}
.styles_root__ifwUT.styles_large__rZBRd {
  height: 72px;
  width: 72px;
}
.styles_root__ifwUT.styles_primary__UY-BN {
  color: #283439;
}
.styles_root__ifwUT.styles_primary__UY-BN:hover {
  background-color: #f7f7f7;
}
.styles_root__ifwUT.styles_primary__UY-BN.styles_fill__Q6Sll {
  background-color: #f7f7f7;
  color: #283439;
}
.styles_root__ifwUT.styles_primary__UY-BN.styles_fill__Q6Sll:hover {
  background-color: #adadad;
}
.styles_root__ifwUT.styles_primary-dark__igGZm {
  color: #283439;
}
.styles_root__ifwUT.styles_primary-dark__igGZm:hover {
  background-color: #e3e3e3;
}
.styles_root__ifwUT.styles_primary-dark__igGZm.styles_fill__Q6Sll {
  background-color: #616161;
  color: white;
}
.styles_root__ifwUT.styles_primary-dark__igGZm.styles_fill__Q6Sll:hover {
  background-color: #444444;
}
.styles_root__ifwUT.styles_secondary__OuYkf {
  color: #0074e0;
}
.styles_root__ifwUT.styles_secondary__OuYkf:hover {
  background-color: #7abfff;
}
.styles_root__ifwUT.styles_secondary__OuYkf.styles_fill__Q6Sll {
  background-color: #0074e0;
  color: white;
}
.styles_root__ifwUT.styles_secondary__OuYkf.styles_fill__Q6Sll:hover {
  background-color: #00519d;
}
.styles_root__ifwUT.styles_success__WRiIf {
  color: #1cab8a;
}
.styles_root__ifwUT.styles_success__WRiIf:hover {
  background-color: #69ddc2;
}
.styles_root__ifwUT.styles_success__WRiIf.styles_fill__Q6Sll {
  background-color: #1cab8a;
  color: white;
}
.styles_root__ifwUT.styles_success__WRiIf.styles_fill__Q6Sll:hover {
  background-color: #137860;
}
.styles_root__ifwUT.styles_error__DI0Ks {
  color: #e23661;
}
.styles_root__ifwUT.styles_error__DI0Ks:hover {
  background-color: #f8b4c4;
}
.styles_root__ifwUT.styles_error__DI0Ks.styles_fill__Q6Sll {
  background-color: #e23661;
  color: white;
}
.styles_root__ifwUT.styles_error__DI0Ks.styles_fill__Q6Sll:hover {
  background-color: #ac193d;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/ui-kit/components/chat-icon-button/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss","webpack://./src/ui-kit/styles/_theme/_transition.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADGA;EEiBI,4EAAA;EFdA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EA8BA,wDAAA;EACA,uDAAA;AA2RJ;AAxTI;EACI,YAAA;AA0TR;AAvTI;EACI,YAAA;EACA,WAAA;AAyTR;AAtTI;EACI,YAAA;EACA,WAAA;AAwTR;AArTI;EACI,YAAA;EACA,WAAA;AAuTR;AApTI;EA9CA,cAgDgB;AAqTpB;AAnWI;EACI,yBAgDqB;AAqT7B;AAlWI;EACI,yBA0CoB;EAzCpB,cA0CiB;AA0TzB;AAlWQ;EACI,yBAAA;AAoWZ;AAtTI;EAzDA,cA2DgB;AAuTpB;AAhXI;EACI,yBA0DqB;AAwT7B;AA/WI;EACI,yBAqDoB;EApDpB,YATmE;AA0X3E;AA/WQ;EACI,yBAAA;AAiXZ;AA3TI;EAjEA,cAmEgB;AA4TpB;AA7XI;EACI,yBAkEqB;AA6T7B;AA5XI;EACI,yBA6DoB;EA5DpB,YATmE;AAuY3E;AA5XQ;EACI,yBAAA;AA8XZ;AAhUI;EAzEA,cA2EgB;AAiUpB;AA1YI;EACI,yBA0EqB;AAkU7B;AAzYI;EACI,yBAqEoB;EApEpB,YATmE;AAoZ3E;AAzYQ;EACI,yBAAA;AA2YZ;AArUI;EAjFA,cAmFgB;AAsUpB;AAvZI;EACI,yBAkFqB;AAuU7B;AAtZI;EACI,yBA6EoB;EA5EpB,YATmE;AAia3E;AAtZQ;EACI,yBAAA;AAwZZ","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme';\n\n@mixin button-colors($color, $hover-bg-color, $fill-bg-color, $fill-color: white) {\n    color: $color;\n\n    &:hover {\n        background-color: $hover-bg-color;\n    }\n\n    &.fill {\n        background-color: $fill-bg-color;\n        color: $fill-color;\n\n        &:hover {\n            background-color: color.scale($color: $fill-bg-color, $lightness: -30%);\n        }\n    }\n}\n\n.root {\n    @include theme.transition(background-color);\n\n    align-items: center;\n    border-radius: 50%;\n    display: inline-flex;\n    flex: 0 0 auto;\n    justify-content: center;\n    overflow: visible;\n    text-align: center;\n\n    &[disabled] {\n        opacity: 0.5;\n    }\n\n    &.small {\n        height: 36px;\n        width: 36px;\n    }\n\n    &.medium {\n        height: 45px;\n        width: 45px;\n    }\n\n    &.large {\n        height: 72px;\n        width: 72px;\n    }\n\n    &.primary {\n        @include button-colors(\n            $color: theme.color(space-500),\n            $fill-bg-color: theme.color(snow-100),\n            $fill-color: theme.color(space-500),\n            $hover-bg-color: theme.color(snow-100)\n        );\n    }\n\n    /* TODO: make color classes camelCase and remove this: */\n    /* stylelint-disable-next-line selector-class-pattern */\n    &.primary-dark {\n        @include button-colors(\n            $color: theme.color(space-500),\n            $fill-bg-color: theme.color(space-400),\n            $hover-bg-color: theme.color(space-100)\n        );\n    }\n\n    &.secondary {\n        @include button-colors(\n            $color: theme.color(ocean-500),\n            $fill-bg-color: theme.color(ocean-500),\n            $hover-bg-color: theme.color(ocean-300)\n        );\n    }\n\n    &.success {\n        @include button-colors(\n            $color: theme.color(green-400),\n            $fill-bg-color: theme.color(green-400),\n            $hover-bg-color: theme.color(green-200)\n        );\n    }\n\n    &.error {\n        @include button-colors(\n            $color: theme.color(red-400),\n            $fill-bg-color: theme.color(red-400),\n            $hover-bg-color: theme.color(red-200)\n        );\n    }\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n","@use 'sass:map';\n@use 'misc' as *;\n\n$easing: (\n    in-sine: cubic-bezier(0.47, 0, 0.745, 0.715),\n    out-sine: cubic-bezier(0.39, 0.575, 0.565, 1),\n    in-out-sine: cubic-bezier(0.445, 0.05, 0.55, 0.95),\n    in-quad: cubic-bezier(0.55, 0.085, 0.68, 0.53),\n    out-quad: cubic-bezier(0.25, 0.46, 0.45, 0.94),\n    in-out-quad: cubic-bezier(0.455, 0.03, 0.515, 0.955),\n    in-cubic: cubic-bezier(0.55, 0.055, 0.675, 0.19),\n    out-cubic: cubic-bezier(0.215, 0.61, 0.355, 1),\n    in-out-cubic: cubic-bezier(0.645, 0.045, 0.355, 1),\n);\n\n$transition-duration: (\n    shortest: 150ms,\n    shorter: 200ms,\n    short: 250ms,\n    standard: 300ms,\n    long: 350ms,\n    longer: 400ms,\n    longest: 500ms\n);\n\n@function ease($name) {\n    @return map.get($easing, $name);\n}\n\n@mixin transition($properties, $duration: standard, $ease: in-out-sine, $delay: 0ms) {\n    $duration-value: map.get($transition-duration, $duration);\n    $timing-function: map.get($easing, $ease);\n\n    @if not $duration-value {\n        $duration-value: $duration;\n    }\n\n    transition: #{$properties} #{$duration-value} #{$timing-function} #{$delay};\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__o6fYH`,
	"ocean-50": `styles_ocean-50__czwkt`,
	"ocean-100": `styles_ocean-100__5HLJj`,
	"ocean-200": `styles_ocean-200__7neRB`,
	"ocean-300": `styles_ocean-300__ixbQ2`,
	"ocean-400": `styles_ocean-400__T9bH0`,
	"ocean-500": `styles_ocean-500__omUzj`,
	"ocean-600": `styles_ocean-600__k+7ye`,
	"space-50": `styles_space-50__DS-hN`,
	"space-100": `styles_space-100__SWd14`,
	"space-200": `styles_space-200__Xg96X`,
	"space-300": `styles_space-300__2y3Xs`,
	"space-400": `styles_space-400__7voLU`,
	"space-500": `styles_space-500__eS+XI`,
	"gray-50": `styles_gray-50__5J7oC`,
	"gray-100": `styles_gray-100__oFu3X`,
	"gray-200": `styles_gray-200__MO5a2`,
	"gray-300": `styles_gray-300__DT+Ji`,
	"gray-400": `styles_gray-400__EH3C-`,
	"gray-500": `styles_gray-500__M58PQ`,
	"green-50": `styles_green-50__WyTUt`,
	"green-100": `styles_green-100__8JElG`,
	"green-200": `styles_green-200__etR4+`,
	"green-300": `styles_green-300__negIl`,
	"green-400": `styles_green-400__+Pu+A`,
	"green-500": `styles_green-500__NuadJ`,
	"red-50": `styles_red-50__ykCmL`,
	"red-100": `styles_red-100__bLXK8`,
	"red-200": `styles_red-200__9TFc9`,
	"red-300": `styles_red-300__-y15i`,
	"red-400": `styles_red-400__KGtrn`,
	"red-500": `styles_red-500__62tZO`,
	"yellow-50": `styles_yellow-50__7tm--`,
	"yellow-100": `styles_yellow-100__3scA+`,
	"yellow-200": `styles_yellow-200__w4Rpv`,
	"yellow-300": `styles_yellow-300__R6EgK`,
	"yellow-400": `styles_yellow-400__4OEC5`,
	"yellow-500": `styles_yellow-500__6phcY`,
	"orange-50": `styles_orange-50__BHjRW`,
	"orange-100": `styles_orange-100__Diuhi`,
	"orange-200": `styles_orange-200__HWCSN`,
	"orange-300": `styles_orange-300__zWIAI`,
	"orange-400": `styles_orange-400__0PcH8`,
	"orange-500": `styles_orange-500__uq07l`,
	"turquoise-50": `styles_turquoise-50__yQ8m2`,
	"turquoise-100": `styles_turquoise-100__snH+d`,
	"turquoise-200": `styles_turquoise-200__puy-E`,
	"turquoise-300": `styles_turquoise-300__8lXUy`,
	"turquoise-400": `styles_turquoise-400__zhAGn`,
	"turquoise-500": `styles_turquoise-500__41TYD`,
	"turquoise-600": `styles_turquoise-600__lFupq`,
	"violet-50": `styles_violet-50__2eilp`,
	"violet-100": `styles_violet-100__M7EsS`,
	"violet-200": `styles_violet-200__JuQLG`,
	"violet-300": `styles_violet-300__Ovdkb`,
	"violet-400": `styles_violet-400__DQt5F`,
	"violet-500": `styles_violet-500__hKMKK`,
	"snow-50": `styles_snow-50__SR8Ux`,
	"snow-100": `styles_snow-100__-5rAI`,
	"snow-200": `styles_snow-200__wUuGL`,
	"snow-300": `styles_snow-300__irIOX`,
	"snow-400": `styles_snow-400__zLgsL`,
	"snow-500": `styles_snow-500__bnjaN`,
	"background-color": `styles_background-color__UdcmN`,
	"ocean": `styles_ocean__GnNvy`,
	"ocean-light": `styles_ocean-light__JXSG5`,
	"green": `styles_green__zFnKR`,
	"green-light": `styles_green-light__w1SKn`,
	"red": `styles_red__HWsPQ`,
	"red-light": `styles_red-light__tYwt3`,
	"orange": `styles_orange__sdYJb`,
	"orange-light": `styles_orange-light__yOBKU`,
	"space": `styles_space__6MuCX`,
	"space-light": `styles_space-light__xcWZ9`,
	"gray-light": `styles_gray-light__+JICI`,
	"violet": `styles_violet__JcYpv`,
	"violet-light": `styles_violet-light__qpPvi`,
	"yellow": `styles_yellow__WCI7J`,
	"yellow-light": `styles_yellow-light__0veC3`,
	"root": `styles_root__ifwUT`,
	"small": `styles_small__IfewV`,
	"medium": `styles_medium__xPzk1`,
	"large": `styles_large__rZBRd`,
	"primary": `styles_primary__UY-BN`,
	"fill": `styles_fill__Q6Sll`,
	"primary-dark": `styles_primary-dark__igGZm`,
	"secondary": `styles_secondary__OuYkf`,
	"success": `styles_success__WRiIf`,
	"error": `styles_error__DI0Ks`
};
export default ___CSS_LOADER_EXPORT___;
